import { render, staticRenderFns } from "./OutingDetail.vue?vue&type=template&id=c3056faa&scoped=true&lang=pug"
import script from "./OutingDetail.vue?vue&type=script&lang=ts"
export * from "./OutingDetail.vue?vue&type=script&lang=ts"
import style0 from "./OutingDetail.vue?vue&type=style&index=0&id=c3056faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3056faa",
  null
  
)

export default component.exports